const memberStatusDisplayNames = {
    active: 'Active',
    invited: 'Invited',
    pending: 'Pending',
    deleted: 'Deactivated'
};
const getMemberStatusDisplayName = (status)=>status in memberStatusDisplayNames ? memberStatusDisplayNames[status] : status;

export { getMemberStatusDisplayName };
//# sourceMappingURL=getMemberStatusDisplayName.mjs.map
